import response from 'fe-coms/utils/response'
import memberApi from './api'
import Vue from '@/app.js'

const http = new Vue().$http
const originRouteNames = [
  'no-auth',
  'local',
  'address',
  'all',
  'demand-portal'
]
export default {
  // 更新checkAuth信息 是否开启游客模式
  async checkAuthUpdate ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      let api = memberApi.getTouristType
      response(http(api.type, api.url)).then(async (res) => {
        if (res.isOk) {
          // 0 关闭 1开启
          if (res.content === 1) {
            // 获取白名单
            await dispatch('getAuthPage')
          } else {
            commit('SET_VISITOR_INFO', {pageList: [...originRouteNames]})
          }
          commit('SET_VISITOR_INFO', {visitor: res.content, updatedAt: Date.now()})
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 初始化用户信息
  async checkAuthInit ({state, dispatch}) {
    // 有现成可用的(且在有效期5分钟内)
    if (state.updatedAt + 5000 > new Date().getTime()) {
      return
    }
    // 获取新的数据
    await dispatch('checkAuthUpdate')
  },
  // 获取白名单
  async getAuthPage ({commit}) {
    const routerKeyMap = {
      pc_mall_home: ['main'],
      pc_equal_commodity: ['compare-price'],
      pc_commodity_purchase: ['channel', 'store', 'store-shop'],
      pc_commodity_list: ['list'],
      pc_commodity_supplier: ['supplier-shop'],
      pc_commodity_info: ['info']
    }
    return new Promise((resolve, reject) => {
      let api = memberApi.common.getWhiteList
      response(http(api.type, api.url)).then((res) => {
        if (res.isOk) {
          const routeNames = []
          const whiteList = res.content || []
          whiteList.forEach(v => {
            if (routerKeyMap[v]) {
              routerKeyMap[v].forEach(it => {
                routeNames.push(it)
              })
            }
          })
          commit('SET_VISITOR_INFO', {pageList: [...originRouteNames, ...routeNames]})
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}
